$(window).on("load", function () {
  // executes when complete page is fully loaded, including all frames, objects and images
  setTimeout(function () {
    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
        navigator.userAgent
      );
    }

    if (isMobile()) {
     
      // Code to run if on a mobile device
      $(".t4s-sub-menu").show();
       $('#menu_mob').removeClass('mb_nav_ham');
      console.log("Mobile device detected.");
    } else {
      // Code to run if not on a mobile device
      console.log("Not a mobile device.");
    }
  }, 3000);
});

$(document).ready(function () {

     $('video').each(function() {
       console.log('video');
        this.play(); 
    });
  
  $(".testimonial_stories").on("click", function () {
    // $(this).hide();
    $(this).closest("section.movement").toggleClass("opened");
    if($(this).closest("section.movement").hasClass('opened'))
    {
      $('.show_less').show();
      $('.show_more').hide();
    }
    else
    {
     
       $('.show_more').show();
       $('.show_less').hide();
    }
  });

  $(".my-slider").slick({
    slidesToShow: 3.99,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $("#slick-prev"),
    nextArrow: $("#slick-next"),
    speed: 600,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

function updateCartItemCustom(action) {
  var quantity = parseInt($(".current_quantity").text());
  if (action == "minus") {
    if (quantity > 1) {
      quantity = quantity - 1;
      $(".current_quantity").text(quantity);
    }
  } else {
    quantity = quantity + 1;
    $(".current_quantity").text(quantity);
  }
}

function rechargeProcessCart() {
  $("#addtocart_custom").addClass("disable");
  $("#order_now").addClass("disable");
  var quantity = parseInt($(".current_quantity").text());

  var curr_watch_variant = $(".gf_selected").attr("data-value");
  if (curr_watch_variant == "Blue") {
    curr_watch_variant = 43891885932765;
  } else if (curr_watch_variant == "Pink") {
    curr_watch_variant = 43891885965533;
  } else if (curr_watch_variant == "Black") {
    curr_watch_variant = 43891885899997;
  }

  var curr_watch_variant = 45701108924637;
  jQuery.post("/cart/clear.js").done(function () {
    jQuery
      .post("/cart/add.js", {
        items: [
          {
            quantity: quantity,
            id: curr_watch_variant,
          },
        ],
      })
      .done(function () {
        setTimeout(function () {
          $("#addtocart_custom").removeClass("disable");
          $("#order_now").removeClass("disable");
        }, 3000);

        // $('.t4s-icon-cart__wrap').trigger('click');
        window.location.href = "/cart";
      });
  });
}

const rotating_images = document.querySelectorAll(".rotating-image");
if (rotating_images.length > 0) {
  let lastScrollTop = 0;
  let angles = new Array(rotating_images.length).fill(0); // To store angles for each image

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;

    // Determine scroll direction
    const isScrollingDown = scrollTop > lastScrollTop;

    // Update angle based on direction
    angles = angles.map((angle, index) => {
      if (isScrollingDown) {
        return angle + 0.5; // clockwise
      } else {
        return angle - 0.5; // anticlockwise
      }
    });

    // Apply rotation to each image
    rotating_images.forEach((image, index) => {
      const scale = image.getAttribute("data-transform-scale") || 1;
      
      image.style.transform = `rotate(${angles[index]}deg) scale(${scale})`;
    });

    // Save current scroll position for next event
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
}